import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState, AppDispatch } from "../../../app/store";
import { pqIndex } from "./pqIndexTypes";
import { getWithAuth } from "../../../utils/api";
import { logError } from "../../../utils/utils";
import { errorHandler } from "../../../utils/errorHandling";

let isFirstLoad = true;
const initialState: pqIndex 
  = {
    selectedTab:"zeitUmspannwerk",
    vorherSelectedTab:"zeitUmspannwerk",

    grenzwertsatzListe: [],
    aktuellerGrenzwertsatz: "",
    aktuellerGrenzwertsatzTemp: "",
    aktuellerGrenzwertsatzVorher: "",
    isChanged: false,
    loadingGrenzwertsatz: false,
    selektierterGrenzwert: "",
    firstLoadOfAnwenden:true,
}

const pqIndexSlice = createSlice({
  name: "pqIndex",
  initialState,
  reducers: 
  {
    setAktuellerGrenzwertsatzTemp: (state, action:PayloadAction<string>) => {
      state.aktuellerGrenzwertsatzTemp = action.payload;
    },
    setAktuellerGrenzwertsatzInit: (state, action:PayloadAction<string>) => {
      state.aktuellerGrenzwertsatz = action.payload;
      state.aktuellerGrenzwertsatzVorher = action.payload;
    },
    setAktuellerGrenzwertsatz: (state) => {
      state.aktuellerGrenzwertsatzVorher = state.aktuellerGrenzwertsatzTemp;
      state.aktuellerGrenzwertsatz = state.aktuellerGrenzwertsatzTemp;

    },
    resetAktuellerGrenzwertsatz: (state) => {
      state.aktuellerGrenzwertsatzTemp = state.aktuellerGrenzwertsatzVorher;
      state.aktuellerGrenzwertsatz = state.aktuellerGrenzwertsatzVorher;
    },
    setSelectedTab:(state, action:PayloadAction<string>) => {
      state.selectedTab = action.payload;
    },
    setVorherSelectedTab:(state, action:PayloadAction<string>) => {
      state.vorherSelectedTab = action.payload;
    },
    setGrenzwertsatzListe: (state, action:PayloadAction<string[]>) => {
      state.grenzwertsatzListe = action.payload;
    },
    setIsChangedGrenzwert:(state, action:PayloadAction<boolean> ) => {
      state.isChanged = action.payload;
    },
    setLoadingGrenzwertsatz: (state, action:PayloadAction<boolean>) => {
      state.loadingGrenzwertsatz = action.payload;
    },
    setFirstLoadOfAnwenden:(state, action:PayloadAction<boolean> ) => {
      state.firstLoadOfAnwenden = action.payload;
    },
  }
});

export const selectSelectedTab = (state: RootState): string => state.pqIndex.selectedTab;
export const selectVorherSelectedTab = (state: RootState): string => state.pqIndex.vorherSelectedTab;
export const selectGrenzwertsatzListe = (state: RootState): string[] => state.pqIndex.grenzwertsatzListe;
export const selectAktuellerGrenzwertsatz = (state: RootState): string => state.pqIndex.aktuellerGrenzwertsatz;
export const selectAktuellerGrenzwertsatzTemp = (state: RootState): string => state.pqIndex.aktuellerGrenzwertsatzTemp;
export const selectIsChangedGrenzwert = (state: RootState): boolean => state.pqIndex.isChanged;
//export const selectAktuellerGrenzwertsatzVorher = (state: RootState): string => state.pqIndex.aktuellerGrenzwertsatzVorher;
export const selectLoadingGrenzwertsatzListe = (state: RootState): boolean => state.pqIndex.loadingGrenzwertsatz;
export const selectFirstLoadOfAnwenden = (state: RootState): boolean => state.pqIndex.firstLoadOfAnwenden;

export const getGrenzwertsatz = () => (dispatch: AppDispatch): void => {
  dispatch(setLoadingGrenzwertsatz(true))
  getWithAuth("GRENZWERTSATZ", {})
    .then((response) => {
      if (isFirstLoad){
        dispatch(setGrenzwertsatzListe(response));
        dispatch(setAktuellerGrenzwertsatzTemp(response[0]));
        dispatch(setAktuellerGrenzwertsatzInit(response[0]));
        isFirstLoad = false;
      }
    })
    .catch((error) => {
      logError(error);
      errorHandler(error, dispatch);
    }).finally(() => dispatch(setLoadingGrenzwertsatz(false)));
};

export const updateSelectedTabAll = (tab: string, vorher: string) => (dispatch: AppDispatch): void => {
  dispatch(setSelectedTab(tab));
  dispatch(setVorherSelectedTab(vorher));
};

export const updateSelectedTab = (tab: string) => (dispatch: AppDispatch): void => {
  dispatch(setSelectedTab(tab));
};

export const updateVorherSelectedTab = (vorher: string) => (dispatch: AppDispatch): void => {
  dispatch(setVorherSelectedTab(vorher));
};

export const {
    setSelectedTab,
    setVorherSelectedTab,
    setGrenzwertsatzListe,
    setAktuellerGrenzwertsatz,
    setAktuellerGrenzwertsatzTemp,
    setAktuellerGrenzwertsatzInit,
    resetAktuellerGrenzwertsatz,
    setIsChangedGrenzwert,
    setLoadingGrenzwertsatz,
    setFirstLoadOfAnwenden
} = pqIndexSlice.actions;

export default pqIndexSlice.reducer;